export enum MODIFIER_ITEM_REQUEST_ID_LIST {
  GET_MODIFIER_ITEMS = 'GET_MODIFIER_ITEMS',
  GET_TOTAL_MODIFIER_ITEMS = 'GET_TOTAL_MODIFIER_ITEMS',
  DELETE_MODIFIER_ITEMS = 'DELETE_MODIFIER_ITEMS',
  TOGGLE_MODIFIER_ITEM_STATUS = 'TOGGLE_MODIFIER_ITEM_STATUS',
  CREATE_MODIFIER_ITEM = 'CREATE_MODIFIER_ITEM',
  UPDATE_MODIFIER_ITEM = 'UPDATE_MODIFIER_ITEM',
}
